// talk·point — Stop-Motion-Motor (snippets/tp-stopmo-frame.liquid), für alle Szenen.
// Scaffold (Text + Fläche) steht serverseitig. Erst wenn der Banner sichtbar
// wird, laden Szenen-CSS (assets/stopmo-<szene>.css) und Figuren; danach wird
// die Bühne eingeblendet (.is-ready). Die Animation läuft nur, solange er
// sichtbar ist (.is-live) — inaktives Slider-Slide oder weggescrollt → Pause,
// beim Wiedersehen geht es weiter.
// Im Hero-Slider hält er das Autoplay an, solange sein Slide aktiv ist (eine
// Story dauert länger als ein Slide-Intervall), und schaltet nach einem
// Durchlauf (--dur der Szene + kurze Pause) selbst weiter.
class TpStopmo extends HTMLElement {
  connectedCallback() {
    this.io = new IntersectionObserver(([e]) => this.view(e.isIntersecting), { threshold: 0.3 });
    this.io.observe(this);
    this.holdSlider();
  }

  disconnectedCallback() {
    this.io?.disconnect();
    this.show?.removeEventListener('slideshow:select', this.onSelect);
    clearTimeout(this.hold);
  }

  // Nur Autoplay wieder starten, das WIR angehalten haben — hat der Nutzer selbst
  // auf Pause gedrückt, bleibt es pausiert.
  async holdSlider() {
    const slide = this.closest('slideshow-slide');
    if (!slide) return;
    await customElements.whenDefined('slideshow-component');
    this.show = this.closest('slideshow-component');
    if (!this.show?.autoplay) return;
    const sync = (active) => {
      if (active && !this.show.paused) {
        this.show.pause();
        this.held = true;
        // Szenen-CSS kann noch fehlen (Lazy-Pfad) → 10 s wie alle Szenen bisher.
        const dur = parseFloat(getComputedStyle(this).getPropertyValue('--dur')) || 10;
        this.hold = setTimeout(() => this.held && this.show.next(), dur * 1000 + 600);
      } else if (!active && this.held) {
        clearTimeout(this.hold);
        this.held = false;
        this.show.play();
      }
    };
    this.onSelect = (e) => sync(e.detail?.slide === slide);
    this.show.addEventListener('slideshow:select', this.onSelect);
    sync(slide.getAttribute('aria-hidden') === 'false');
  }

  async view(on) {
    if (on) await (this.ready ||= this.load());
    this.classList.toggle('is-live', on);
  }

  load() {
    // Ein <link> pro Szene, auch wenn sie mehrfach auf der Seite steht (Hero + PDP-Streifen).
    const href = this.dataset.css;
    let link = document.querySelector(`link[data-stopmo="${this.dataset.scene}"]`);
    const css = link?.sheet
      ? null
      : new Promise((done) => {
          if (!link) {
            link = Object.assign(document.createElement('link'), { rel: 'stylesheet', href });
            link.dataset.stopmo = this.dataset.scene;
            document.head.append(link);
          }
          link.addEventListener('load', done, { once: true });
          link.addEventListener('error', done, { once: true });
        });
    const imgs = [...this.querySelectorAll('img')].map((img) => {
      img.loading = 'eager';
      return img.decode().catch(() => {});
    });
    return Promise.all([css, ...imgs]).then(() => this.classList.add('is-ready'));
  }
}

if (!customElements.get('tp-stopmo')) customElements.define('tp-stopmo', TpStopmo);
